import type { NextRouter } from "next/router";
import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import {
	usePasswordValidation,
	useConnectAndRedirect,
	usePasswordSubmissions,
} from "@Front/Components/Layouts/Login/hooks/helpers/loginSubmissionHooks";
import type { CustomerLoginState } from "@Front/Components/Layouts/Login/hooks/helpers/loginStateHook";

export function useLoginPasswordSubmissionPart(params: {
	router: NextRouter;
	loginScope: CustomerLoginRouterScope;
	loginState: CustomerLoginState;
	refresh: () => Promise<void>;
}): {
	onNewPasswordSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: Record<string, string>) => Promise<void>;
	onPasswordSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: Record<string, string>) => Promise<void>;
} {
	const { router, loginScope, loginState, refresh } = params;
	const { totpCode, email, authDisambiguation, setValidationErrors } = loginState;

	const handlePasswordValidation = usePasswordValidation();
	const connectAndRedirect = useConnectAndRedirect(router, refresh, setValidationErrors);
	return usePasswordSubmissions({
		totpCode,
		email,
		...loginScope,
		authDisambiguation,
		handlePasswordValidation,
		connectAndRedirect,
		setValidationErrors,
	});
}
